import React from "react";
import CompletedIcon from "../../../../assets/completed.svg";
import InProgressIcon from "../../../../assets/in-progress.svg";
import { useTheme } from "@mui/material";

export interface TableStateProps {
  state: boolean;
  height?: string;
  width?: string;
  maxHeight?: string;
  maxWidth?: string;
  qty?: number;
  blocker?: number;
  BlockerIcon?: string;
}

const TableState: React.FC<TableStateProps> = ({
  state,
  height,
  width,
  maxHeight,
  maxWidth,
  qty,
  blocker,
  BlockerIcon,
}) => {
  const theme = useTheme();

  // Show blocker icon if blocker is 1
  if (blocker === 1 && BlockerIcon) {
    return (
      <img
        src={BlockerIcon}
        style={{
          height: height || "16px",
          width: width || "16px",
          maxHeight,
          maxWidth,
        }}
        alt="blocker"
      />
    );
  }

  if (qty !== undefined && qty >= 0) {
    return (
      <div
        style={{
          backgroundColor: theme.palette.customColors.purple,
          color: theme.palette.customColors.white,
          borderRadius: "50%",
          padding: "6px 10px",
          fontSize: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 500,
          minHeight: "24px",
          width: "30px",
          height: "30px",
          minWidth: "30px",
          maxHeight,
          maxWidth,
          textAlign: "center",
          lineHeight: 1,
        }}
      >
        {qty}
      </div>
    );
  }
  return (
    <>
      {state ? (
        <img
          src={CompletedIcon}
          style={{
            height,
            width,
            maxHeight,
            maxWidth,
          }}
          alt="completed"
        />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
            minHeight: height || "16px",
          }}
        >
          <img
            src={InProgressIcon}
            style={{
              height,
              width,
              maxHeight,
              maxWidth,
            }}
            alt="in-progress"
          />
        </div>
      )}
    </>
  );
};

export default TableState;
